import InfoValuator from '@/pages/Narrative/components/NarrativeCommunityHeader/images/info-valuator.svg';
import InfoAlert from '@/pages/Narrative/components/NarrativeCommunityHeader/images/info-alert.svg';
import InfoDiscussion from '@/pages/Narrative/components/NarrativeCommunityHeader/images/info-discussion.svg';
import type { ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  children: ReactNode;
};

export const WelcomeStepInfoBlock = ({ icon, children }: Props) => {
  return (
    <div
      role="listitem"
      className="grid grid-cols-[60px_auto] items-center gap-x-3"
    >
      <div className="relative flex items-center justify-center">
        <div className="absolute inset-3 bg-p-grey-10 blur-2xl lg:inset-1" />
        <div className="relative z-10">{icon}</div>
      </div>
      <p className="text-pretty text-sm leading-relaxed text-solid">
        {children}
      </p>
    </div>
  );
};

const WelcomeStep = () => {
  return (
    <div className="mt-2">
      <h1 className="m-0 mb-2 gap-2 text-xl font-strong text-p-blue-60 [word-break:break-word]">
        Welcome to the Community
      </h1>
      <p className="text-sm text-solid">
        Our community narratives are driven by numbers and valuation.
      </p>
      <div role="list" className="grid grid-cols-1 justify-between gap-x4">
        <WelcomeStepInfoBlock
          icon={<InfoValuator width="60px" height="60px" />}
        >
          Value any stock for free in seconds
        </WelcomeStepInfoBlock>
        <WelcomeStepInfoBlock icon={<InfoAlert width="60px" height="60px" />}>
          Get alerts and valuation updates
        </WelcomeStepInfoBlock>
        <WelcomeStepInfoBlock
          icon={<InfoDiscussion width="60px" height="60px" />}
        >
          Participate in discussions
        </WelcomeStepInfoBlock>
      </div>
    </div>
  );
};

export { WelcomeStep, WelcomeStep as default };
